import { Text, TextProps } from '@shopify/polaris';
import { memo } from 'react';
type IAlignment = 'start' | 'center' | 'end' | 'justify';

const RegularText = ({
  children,
  alignment,
  tone,
  className,
}: {
  children: React.ReactNode;
  alignment?: IAlignment;
  tone?: TextProps['tone'];
  className?: string;
}) => {
  return (
    <Text tone={tone} as="span" variant="bodyMd" alignment={alignment}>
      <span className={className}>{children}</span>
    </Text>
  );
};
export default memo(RegularText);
